import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../gd-components/base-component/base-component";

import Form from '../../../gd-form/form/form-modal-new/form-modal-new';
import FormManager from '../../../gd-form/common/form-manager';
import FormError from '../../../gd-form/common/form-error/form-error';
import Input from '../../../gd-form/form-element/input/input';

import Classes from 'classnames';

export default class NewProjectViewModal extends BaseComponent {

    static propTypes = {
        projectId: PropTypes.string,
        viewId: PropTypes.number,
        name: PropTypes.string,

        onSubmit: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        const isFullAccess = gd.ac.check.project.fullAccess(props.projectId);

        const initFormData = {
            name: _.get(this.props, 'name', ''),
            access: isFullAccess ? 'public' : 'private'
        };

        const formStructure = {
            isFormChanged: true,
            fields: {
                name: {
                    type: 'input',
                    validator: val => _.isNil(val) || val.trim() === '' ? 'No valid characters found' : true
                },

                access: {
                    type: 'select',
                    isRequired: true
                }
            },
            onSubmit: this.onSubmit
        };

        this.form = new FormManager(formStructure,initFormData);
    }

    onClickOption = (value) => {
        this.form.setFieldValue("access", value);
        this.forceUpdate();
    };

    onSubmit = (result) => {
        // result.id = gd.utils.guid();
        //
        // const options = ViewsPresetsManager.getViewPresetsOptions(this.props.projectId, this.props.viewId, false)
        // result.sortPosition = options.length + 1;

        this.props.onSubmit(result);
    };

    render() {
        const selectedOption = this.form.getValue("access");
        const isFullAccess = gd.ac.check.project.fullAccess(this.props.projectId);

        // supports disabled (!)
        const options = [
            // { id: 'public',     title: 'Public',    description: 'Visible to all users, can be modified by users with full access', disabled: !isFullAccess},
            { id: 'public',     title: 'Public',    description: 'Visible to all users, can be modified by users with full access', disabled: !isFullAccess},
            // { id: 'protected',  title: 'Protected', description: 'Visible to all users, can be modified by you only', icon: 'ii5-shield'},
            { id: 'private',    title: 'Private',   description: 'Visible to you only', icon: 'i5-lock-solid'}
        ];

        return (
            <Form form={this.form} submitLabel="Save">
                <div className="tbl">
                    <div className="row">
                        <div className="label">Name</div>
                        <div className="element">
                            <Input size="big" form={this.form} name="name" />
                            <FormError form={this.form} name="name" />
                        </div>
                    </div>
                </div>

                <div className="tbl">
                    <div className="row">
                        <div className="label top">Access</div>
                        <div className="element available-options">
                            {options.map(o=>{
                                const classes = Classes("save-preset-option", {
                                    "is-selected": selectedOption === o.id,
                                    "disabled": o.disabled
                                });

                                return (
                                    <div key={o.id} className={classes} onClick={o.disabled ? ()=>{} : this.onClickOption.bind(this,o.id)}>
                                        <div className="option-selection-icon"/>
                                        <div className="option-label">
                                            {o.title}
                                            {!!o.icon && <div className={Classes("option-icon", o.icon)}/>}
                                        </div>

                                        <div className="option-description">{o.description}</div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </Form>
        );
    }
}